import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import FormComponentState from './states'
import { State } from '@/store/store'

const formComponents: Module<FormComponentState, State> = {
  state: new FormComponentState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default formComponents
